<template>

  <h1 class="visually-hidden" v-if="messages">{{ hiddenh1 }}</h1>

  <!-- breadcrumbs -->
  <div class="container-fluid breadcrumbs d-none d-md-block">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a :href="langMain">{{ $t('detailviews.home') }}</a></li>
              <li class="breadcrumb-item active" aria-current="page">{{ $t('detailviews.counselingCenters') }}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- breadcrumbs END -->

  <main id="main" class="">

    <!-- karte -->
    <section class="container kartenbox mb-4 px-xs-0" id="karte" :aria-label="$t('searchlist.search')">
      <div class="row mx-0">
        <div class="col-12 col-md-6 col-lg-3 ps-0 px-xs-0">
          <!-- <Suche :topics="topics" :regions="regions" :messages="searchMessages" type="search" /> -->
          <WidgetBeratungsSuche :messages="messages" type="search" :selectedTopics="topics" :selectedRegion="regions"
            @submit="getnewtopics" :selectedLong="long" :selectedLat="lat" :key="componentKey" />
        </div>


        <div class="col-12 col-md-6 col-lg-9 p-0 ps-5px bg-white d-nonex d-md-block position-relative">
          <div class="karte" id="karte-desktop" ref="kartedesktop" aria-labelledby="karte-headline">
            <div id="karte-headline" class="visually-hidden">{{ $t('searchlist.mapHL') }}</div>
            <Karte :c-centers="filteredCenter" :show-search-area-overlay="false"
              @updateFromAreaSearchButton="searchArea" />
          </div>
        </div>
      </div>
    </section>
    <!-- karte END -->

    <div class="container px-0">
      <div class="row mx-0">

        <div class="col-12 col-md-6 col-lg-3 px-xs-0 ps-sm-0 d-none d-md-block" id="ergebnisfilter-holder">
          <!-- v-if="filteredCenter.length > 0"> -->
          <div id="ergebnis-filter" ref="ergebnisfilter" tabindex="0" aria-labelledby="ergebnis-headline">

            <div class="ergebnis-filter-box">

              <div class="d-flex align-items-center">
                <img src="../../assets/img/filter.svg" width="20" height="20" :alt="$t('searchlist.filterIcon')"
                  aria-hidden="true" class="me-3">
                <h2 class="filter-headline" id="ergebnis-headline">{{ $t('searchlist.filter') }}</h2>
              </div>

              <div class="input-group position-relative mt-3">
                <label for="search-menue" class="visually-hidden">{{ $t('searchlist.searchTerm') }}</label>
                <input type="text" id="search-menue" name="q" class="form-control custom-search-input w-100"
                  :placeholder="$t('searchlist.search')" v-model="searchTerm" @keyup.enter="searchByTerm()"
                  @input="searchByTerm()" aria-controls="ergebnis-liste">
                <button class="btn btn-suche bg-white custom-search-button custom-search-button-delete" role="button"
                  @click="resetTerm()" v-if="searchTerm && searchTerm.length > 3">
                  <img src="../../assets/img/close_x.svg" width="10" height="10" :alt="$t('searchlist.deleteIcon')"
                    aria-hidden="true">
                  <span class="visually-hidden alert-primary">{{ $t('searchlist.resetInput') }}</span>
                </button>
                <button class="btn btn-suche bg-white custom-search-button" role="button" @click="searchByTerm()">
                  <img src="../../assets/img/suche_Lupe_black.svg" width="20" height="20"
                    :alt="$t('searchlist.searchIcon')" aria-hidden="true">
                  <span class="visually-hidden alert-primary">{{ $t('searchlist.search') }}</span>
                </button>
              </div>


            </div> <!-- /.ergebnis-filter-box -->

            <div class="ergebnis-filter-box">
              <h3>{{ $t('searchlist.onlineCounseling') }}</h3>
              <ul class="list-unstyled">
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="Chat" name="os" :id="'cb_beratung_chat'"
                      v-model="checkedOnlineService" @change="checkOnlineService($event)"
                      aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center" :for="'cb_beratung_chat'">
                      {{ $t('views.counselingCenters.chatConsult') }}&nbsp;<i class="icon onb-contact--chat" />
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number">{{ countChatSystems }}</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="Video" name="os" :id="'cb_beratung_video'"
                      v-model="checkedOnlineService" @change="checkOnlineService($event)"
                      aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center" :for="'cb_beratung_video'">
                      {{ $t('views.counselingCenters.videoConsult') }}&nbsp;<i class="icon onb-contact--video" />
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number">{{ countVideoSystems }}</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="Mail" name="os" :id="'cb_beratung_mail'"
                      v-model="checkedOnlineService" @change="checkOnlineService($event)"
                      aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center" :for="'cb_beratung_mail'">
                      {{ $t('views.counselingCenters.mailConsult') }}&nbsp;<i class="icon onb-contact--mail" />
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number">{{ countMailSystems }}</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>


            <div class="ergebnis-filter-box" v-if="filterTargetGroup && filterTargetGroup.length > 0">
              <h3>{{ $t('searchlist.targetGroup') }}</h3>
              <ul class="list-unstyled">
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" value="" name="tg" id="cb_beratung_all"
                      v-model="checkedTargetGroup" :checked="checkedTargetGroup == ''" @change="checkTargetGroup()"
                      aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center" for="cb_beratung_all">
                      <span>{{ $t('searchlist.all') }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number"
                        v-if="filteredCenter.length > 0">{{ countTargetGroupAll }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number" v-else>0</span>


                    </label>
                  </div>
                </li>
                <li v-for="(item, index) in filterTargetGroup" :key="index">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" :value="item.id" name="tg" :id="'cb_beratung_' + item.id"
                      v-model="checkedTargetGroup"
                      :checked="(item.id === checkedTargetGroup && countTargetGroup.get(item.id) !== 0)"
                      @change="checkTargetGroup()" :disabled="countTargetGroup.get(item.id) === 0"
                      aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center"
                      :for="'cb_beratung_' + item.id">
                      <span>{{ item.description }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number"
                        v-if="filteredCenter.length > 0">{{ countTargetGroup.get(item.id) }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number" v-else>0</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>

            <div class="ergebnis-filter-box" v-if="filterLang && filterLang.length > 0">
              <h3>{{ $t('searchlist.language') }}</h3>
              <ul class="list-unstyled">
                <li v-for="(item, index) in filterLang" :key="index">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="item.id" v-model="checkedLanguageType"
                      name="lang" :id="item.id" @change="checkLanguageType($event)"
                      :checked="(item.id === checkedLanguageType.id && countLang.get(item.id) !== 0)"
                      :disabled="countLang.get(item.id) === 0" aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center" :for="item.id">
                      <span>{{ item.description }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number"
                        v-if="filteredCenter.length > 0">{{ countLang.get(item.id) }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number" v-else>0</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>

            <div class="ergebnis-filter-box" v-if="filterType && filterType.length > 0">
              <h3>{{ $t('searchlist.counselingType') }}</h3>
              <ul class="list-unstyled">
                <li v-for="(item, index) in filterType" :key="index">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="item.id" v-model="checkedCounselingType"
                      name="ctype" :id="item.id" @change="checkCounselingType($event)"
                      :checked="(item.id === checkedCounselingType.id && countCounseling.get(item.id) !== 0)"
                      :disabled="countCounseling.get(item.id) === 0" aria-controls="ergebnis-liste">
                    <label class="form-check-label checkbox-label d-flex align-items-center" :for="item.id">
                      <span>{{ item.description }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number"
                        v-if="filteredCenter.length > 0">{{ countCounseling.get(item.id) }}</span>
                      <span class="ms-auto ps-2 pe-1 checkbox-label-number" v-else>0</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="ergebnis-filter-box">
              <button class="btn btn-primary-custom mb-3 d-block d-md-none w-100" id="btn-filter-mobile"
                @click="openListe()">{{ $t('searchlist.save') }}</button>
              <button class="btn btn-link-custom d-block w-100" id="btn-filter-reset" @click="resetFilter()">{{
                $t('searchlist.resetFilter') }}</button>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-9 px-xs-0 mt-4 mt-md-0 pe-md-0 padding-ergebnisliste-start">
          <!-- :class="(filteredCenter.length == 0) ? 'ps-0 col-md-12 col-lg-12' : ''"> -->
          <div id="ergebnis-liste" aria-live="polite" aria-relevant="additions removals" ref="ergebnisliste"
            tabindex="0" aria-labelledby="liste-headline">
            <div class="visually-hidden" id="liste-headline">{{ $t('searchlist.listHL') }}</div>
            <loading-container :state="state" i18nErrorMessage="views.legalEntities.errorMessage">
              <Liste :cCenter=filteredCenter :topics=topics :key="filteredCenter" :region="regions"
                :lang="checkedLanguageType" :cType="checkedCounselingType" :targetGroup="checkedTargetGroup"
                :os="checkedOnlineService" :long="long" :lat="lat" :radiusMap="radiusMap" :searchTerm="searchTerm"
                @submit="getnewtopics" @resetfilter="resetFilter" />

            </loading-container>
          </div>
        </div> <!-- col-12 col-md-9 -->

      </div> <!-- /row -->
    </div> <!-- /container -->


    <!-- mobile-switch liste, karte, filter-->
    <div class="d-block d-md-none d-flex justify-content-evenly" id="mobileSwitch" v-if=isMobile>

      <button @click="openFilter()" id="switchFilter" class="btn d-flex flex-column btn-switch d-noxne">
        <img src="../../assets/img/switch-filter.svg" width="30" height="30" alt="Icon Filter" aria-hidden="true"
          class="mx-auto mb-1">
        <span>{{ $t('searchlist.mobileFilter') }}</span>
      </button>

      <button @click="openMap()" id="switchMap" class="btn d-flex flex-column btn-switch d-noxne" tabindex="-1">
        <img src="../../assets/img/switch-karte.svg" width="30" height="30" alt="Icon Map" aria-hidden="true"
          class="mx-auto mb-1">
        <span>{{ $t('searchlist.mobileMap') }}</span>
      </button>

      <button @click="openListe()" id="switchListe" class="btn d-flex flex-column btn-switch d-noxne">
        <img src="../../assets/img/switch-liste.svg" width="30" height="30" alt="Icon Liste" aria-hidden="true"
          class="mx-auto mb-1">
        <span>{{ $t('searchlist.mobileList') }}</span>
      </button>
    </div>

  </main>

</template>

<script lang="ts">
import { defineComponent } from 'vue'
import WidgetBeratungsSuche from '@/top-level/WidgetBeratungsSuche.vue'
import Karte from '@/components/ergebnisliste/Karte.vue'
import Liste from '@/components/ergebnisliste/Liste.vue'

import counselingCenterService from '@/services/counselingCenterService'
import {
  CounselingCenterSearchResultDto,
  CounselingSystemType,
  FacetResultCounselingCenterSearchResultDto,
  ObjectStatus,
  RegionType
} from '@/generated/openapi/api'

import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import LoadingMixin from '@/mixins/LoadingMixin'
import { LoadingState } from '@/utils/loadingUtils'

import { mapActions } from "vuex";

import config from "@/config/config"
// import { distanceAndSkiddingToXY } from '@popperjs/core/lib/modifiers/offset'
import { get as _get } from "lodash"

export default defineComponent({
  name: 'ViewErgebnisliste',
  props: {
    messages: String,
  },
  components: {
    Liste,
    Karte,
    WidgetBeratungsSuche,
    LoadingContainer
  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      isMobile: false,
      topics: [] as any,
      regions: '',
      cCenter: {} as FacetResultCounselingCenterSearchResultDto,
      checkedCounselingType: [] as any,
      checkedLanguageType: [] as any,
      checkedOnlineService: [] as any,
      checkedTargetGroup: '',
      searchTerm: '',
      filteredCenter: [] as CounselingCenterSearchResultDto[],
      countLang: new Map(),
      countCounseling: new Map(),
      countTargetGroup: new Map(),
      countTargetGroupAll: 0,
      countOnlineService: new Map(),
      countOnlineServicesAll: 0,
      countChatSystems: 0,
      countVideoSystems: 0,
      countMailSystems: 0,
      searchMessages: Object,
      showTargetGroup: false,
      long: '',
      lat: '',
      sortCCby: '' as any,
      componentKey: 0,
      radiusMap: 40,
      filteredCenterOld: [] as CounselingCenterSearchResultDto[],
      openMapSave: false,
      openListeSave: true,
      openFilterSave: false,
      langMain: 'de',
      withOnlineCounseling: false
    }
  },
  mounted() {
    // this.initOnlineCounseling();
    const tempLang = (document && document.getElementsByTagName('html') && document.getElementsByTagName('html')[0].getAttribute('lang')) || 'de';
    if (tempLang === 'en') {
      this.langMain = '/en/'
    } else {
      this.langMain = '/'
    }

    if (document && document.body && document.body.classList.contains("frauen")) {
      this.showTargetGroup = true
    }
    this.hideAllElements();
    this.onResize()
    window.addEventListener('resize', this.onResize)

    if (this.messages) {
      this.searchMessages = Object.assign({}, JSON.parse(this.messages))
    }

    this.getUrlParams();

    this.getAllLookUpValues().then(_ => {
      // this.initOnlineCounseling();
      this.loadCC();
    }).catch(_ => {
      // not loaded
    });
  },
  computed: {
    filterLang(): any {
      let filtered = [] as any;
      for (let j = 0; j < this.getLanguageLookupValue.length; j++) {
        let lookupvalueid = this.getLanguageLookupValue[j].id
        if (this.countLang.has(lookupvalueid)) {
          if (this.countLang.get(lookupvalueid) !== 0) {
            filtered.push(this.getLanguageLookupValue[j])
          }
        }
      }
      return filtered
    },
    filterType(): any {
      let filtered = [] as any;
      for (let j = 0; j < this.getCounselingTypeLookupValue.length; j++) {
        let lookupvalueid = this.getCounselingTypeLookupValue[j].id
        if (this.countCounseling.has(lookupvalueid)) {
          if (this.countCounseling.get(lookupvalueid) !== 0) {
            filtered.push(this.getCounselingTypeLookupValue[j])
          }
        }
      }
      return filtered
    },
    filterTargetGroup(): any {
      let filtered = [] as any;
      if (this.showTargetGroup) {
        for (let j = 0; j < this.getTargetGroupLookupValue.length; j++) {
          let lookupvalueid = this.getTargetGroupLookupValue[j].id
          if (this.countTargetGroup.has(lookupvalueid)) {
            if (this.countTargetGroup.get(lookupvalueid) !== 0) {
              filtered.push(this.getTargetGroupLookupValue[j])
            }
          }
        }
      }
      return filtered
    },
    filterOnlineService(): any {
      let filtered = [] as any;
      if (this.showTargetGroup) {
        for (let j = 0; j < this.getTargetGroupLookupValue.length; j++) {
          let lookupvalueid = this.getTargetGroupLookupValue[j].id
          if (this.countTargetGroup.has(lookupvalueid)) {
            if (this.countTargetGroup.get(lookupvalueid) !== 0) {
              filtered.push(this.getTargetGroupLookupValue[j])
            }
          }
        }
      }
      return filtered
    },
    hiddenh1(): string {
      // if(this.messages){
      //   let temp = JSON.parse(this.messages)
      //   return temp.headline
      // }else{
      let titleOri = document.title;
      if (titleOri.length == 0 || titleOri === "") {
        titleOri = this.$t("detailviews.consultation");
      }
      const title = titleOri.split('-');
      return title[0].trim();
      // }
    },
    getLanguageLookupValue(): any {
      let langs = [];
      if (this.$store.state.lookUpValues.has('LANGUAGE')) {
        langs = this.$store.state.lookUpValues.get('LANGUAGE');
      }
      return langs
    },
    getCounselingTypeLookupValue(): any {
      let ctype = [];
      if (this.$store.state.lookUpValues.has('COUNSELING_TYPE')) {
        ctype = this.$store.state.lookUpValues.get('COUNSELING_TYPE');
      }
      return ctype
    },
    getTargetGroupLookupValue(): any {
      let tg = [];
      if (this.$store.state.lookUpValues.has('TARGET_GROUP')) {
        tg = this.$store.state.lookUpValues.get('TARGET_GROUP');
      }
      return tg
    },
    getTopicsLookupValue(): any {
      let tg = [];
      if (this.$store.state.lookUpValues.has('TOPICS')) {
        tg = this.$store.state.lookUpValues.get('TOPICS');
      }
      return tg
    },
  },
  methods: {
    // initOnlineCounseling() {
    //   let persisted = sessionStorage.getItem('withOnlineCounseling');

    //   if (persisted != null) {
    //     this.checkedOnlineService = [];
    //   }

    //   this.withOnlineCounseling = persisted !== null ? JSON.parse(persisted) : false;

    //   if (this.withOnlineCounseling) {
    //     this.checkedOnlineService = ['Mail', 'Chat', 'Video'];
    //   }
    // },
    forceRerender() {
      this.componentKey += 1;
    },
    getnewtopics(...value: any) {
      // this.initOnlineCounseling();
      this.topics = value[0];
      //reset filter
      this.long = '';
      this.lat = '';
      this.regions = '';
      this.sortCCby = '';
      this.radiusMap = 40;
      this.searchTerm = '';

      // if reset (alle stellen suchen -> del all filter)
      //if(value[0].length === 0 && value[1].length === 0 && value[2].length === 0){
      //keine kartensuche -> del all filter, wenn kartenumkreissuche doch kommt nur bei reset filter löschen
      this.checkedLanguageType = []
      this.checkedCounselingType = []
      this.checkedTargetGroup = ""
      // this.checkedOnlineService = []
      // }

      let lat = '';
      if (value[2] && value[2].length > 0) {
        lat = value[2][0]
        this.lat = lat
      }
      let long = '';
      if (value[2] && value[2].length > 0) {
        long = value[2][1]
        this.long = long
      }

      if (value[1]) {
        this.regions = value[1]
      }

      if (value[3]) {
        this.withOnlineCounseling = value[3]
      }

      if (value[4]) {
        //  this.withOnlineCounseling = value[4]
      }

      if (!this.withOnlineCounseling) {
        this.checkedOnlineService = []
      }

      this.pushUrl()
      this.loadCC()
      this.forceRerender()
    },
    pushUrl() {
      this.$router.push({ query: { ctype: this.checkedCounselingType, lang: this.checkedLanguageType, topic: this.topics, tg: this.checkedTargetGroup, region: this.regions, long: this.long, lat: this.lat, radius: this.radiusMap, searchTerm: this.searchTerm, os: this.checkedOnlineService } })
    },
    searchByTerm() {
      this.pushUrl();
      this.filterCC('');
    },
    resetTerm() {
      this.searchTerm = '';
      this.filterCC('');
    },
    resetFilter() {
      this.searchTerm = '';
      this.checkedLanguageType = []
      this.checkedCounselingType = []
      this.checkedTargetGroup = ""
      this.checkedOnlineService = [];
      this.pushUrl();
      this.filterCC('');
    },
    checkCounselingType(event: Event) {
      // console.log('ctype pressedn: ', this.checkedCounselingType, this.checkedCounselingType.length)

      if (event && event.target && (event.target as HTMLInputElement).checked) {
        this.filterCC('ctype')
        this.countFilterOld(this.filteredCenter, 'ctype')
      } else {
        this.filterCC('')
      }
      this.pushUrl();
      this.countAllTargetGroups(this.cCenter.content);
    },
    checkLanguageType(event: Event) {
      this.pushUrl();

      if (event && event.target && (event.target as HTMLInputElement).checked) {
        this.filterCC('lang');
        this.countFilterOld(this.filteredCenter, 'lang')
      } else {
        this.filterCC('');
      }
      this.countAllTargetGroups(this.cCenter.content);
    },
    checkTargetGroup() {
      this.pushUrl();
      if (this.checkedTargetGroup !== "") {
        // console.log('filter tg')
        this.filterCC('tg');
        // this.countFilterOld(this.filteredCenter,'tg')
      } else {
        // console.log('no filter tg')
        this.filterCC('')
      }
    },
    checkOnlineService(event: Event) {
      this.pushUrl();

      if (event && event.target && (event.target as HTMLInputElement).checked) {
        this.filterCC('os');
        this.countFilterOld(this.filteredCenter, 'os')
      } else {
        //sessionStorage.setItem('withOnlineCounseling', JSON.stringify(false));
        this.filterCC('');
      }
      this.countAllTargetGroups(this.cCenter.content);
    },

    ...mapActions(['getAllLookUpValues']),

    // only load mobile-menu on smaller screen
    onResize() {
      if (window.innerWidth < 768) {
        this.isMobile = true;
        this.hideAllElements();
        if (this.openListeSave) {
          this.openListe();
        }
        else if (this.openMapSave) {
          this.openMap();
        }
        else if (this.openFilterSave) {
          this.openFilter();
        }
        else {
          this.openListe();
        }
      } else {
        this.isMobile = false;
        this.hideAllElements();
        this.showAllElements();

      }
    },
    hideAllElements() {
      const karte = document.getElementById('karte-desktop');
      if (karte) {
        karte.classList.add('invisible');
        karte.classList.remove('visible');
        karte.classList.remove('overlayfixed')
      }
      const filter = document.getElementById('ergebnisfilter-holder');
      if (filter) {
        filter.classList.add('d-none');
        filter.classList.remove('d-block');
        filter.classList.remove('overlayfixed')
      }
    },
    showAllElements() {
      const karte = document.getElementById('karte-desktop');
      if (karte) {
        karte.classList.remove('invisible');
        karte.classList.add('visible');
      }
      const filter = document.getElementById('ergebnisfilter-holder');
      if (filter) {
        filter.classList.remove('d-none');
        filter.classList.add('d-block');
      }

      const liste = document.getElementById('ergebnis-liste');
      if (liste) {
        liste.classList.add('d-block');
        liste.classList.remove('d-none');
      }
    },
    openListe() {
      this.openListeSave = true;
      this.openFilterSave = false;
      this.openMapSave = false;

      const karte = document.getElementById('karte-desktop');
      if (karte) {
        karte.classList.add('invisible');
        karte.classList.remove('overlayfixed')
      }
      const filter = document.getElementById('ergebnisfilter-holder');
      if (filter) {
        filter.classList.add('d-none');
        filter.classList.remove('overlayfixed')
      }

      const liste = document.getElementById('ergebnis-liste');
      if (liste) {
        liste.classList.add('d-block');
        liste.classList.remove('d-none');
        // const ef = this.$refs.ergebnisliste as any
        // ef.focus()
      }
    },
    openMap() {
      this.openListeSave = false;
      this.openFilterSave = false;
      this.openMapSave = true;

      const karte = document.getElementById('karte-desktop');
      if (karte) {
        karte.classList.add('visible');
        karte.classList.add('overlayfixed')
        karte.classList.remove('invisible');
        const ef = this.$refs.kartedesktop as any
        ef.focus()
      }
      const filter = document.getElementById('ergebnisfilter-holder');
      if (filter) {
        filter.classList.add('d-none');
        filter.classList.remove('overlayfixed')
      }

      const liste = document.getElementById('ergebnis-liste');
      if (liste) {
        liste.classList.add('d-none');
      }

    },
    openFilter() {
      this.openListeSave = false;
      this.openFilterSave = true;
      this.openMapSave = false;
      //console.debug('set overlayfixed')
      const karte = document.getElementById('karte-desktop');
      if (karte) {
        karte.classList.add('invisible');
        karte.classList.remove('overlayfixed')
      }
      const filter = document.getElementById('ergebnisfilter-holder');
      if (filter) {
        filter.classList.remove('d-none');
        filter.classList.add('d-block')
        filter.classList.add('overlayfixed');
        const ef = this.$refs.ergebnisfilter as any
        ef.focus()
      }
      const liste = document.getElementById('ergebnis-liste');
      if (liste) {
        liste.classList.add('d-none');
      }

    },
    getUrlParams() {
      if (this.$route.query.topic) {
        if (typeof this.$route.query.topic === "string") {
          this.topics.push(this.$route.query.topic)
        } else {
          this.topics = this.$route.query.topic
        }
      } else {
        this.topics = this.getTopicsLookupValue;
      }

      if (this.$route.query.region) {
        if (typeof this.$route.query.region === "string") {
          this.regions = this.$route.query.region
        }
        // console.log('region:',this.regions)
      }

      if (this.$route.query.lang) {
        if (typeof this.$route.query.lang === "string") {
          this.checkedLanguageType.push(this.$route.query.lang)
        } else {
          this.checkedLanguageType = this.$route.query.lang
        }
      }

      if (this.$route.query.os) {
        if (typeof this.$route.query.os === "string") {
          this.checkedOnlineService.push(this.$route.query.os)
        } else {
          this.checkedOnlineService = this.$route.query.os
        }
      }

      if (this.$route.query.ctype) {
        if (typeof this.$route.query.ctype === "string") {
          this.checkedCounselingType.push(this.$route.query.ctype)
        } else {
          this.checkedCounselingType = this.$route.query.ctype
        }
      }

      if (this.showTargetGroup) {
        if (this.$route.query.tg) {
          if (typeof this.$route.query.tg === "string") {
            this.checkedTargetGroup = this.$route.query.tg
          }
        }
      }

      if (this.$route.query.long) {
        if (typeof this.$route.query.long === "string") {
          this.long = this.$route.query.long
        }
      }

      if (this.$route.query.lat) {
        if (typeof this.$route.query.lat === "string") {
          this.lat = this.$route.query.lat
        }
      }

      if (this.$route.query.coords) {
        if (typeof this.$route.query.coords !== "string") {
          this.lat = this.$route.query.coords[0] || ''
          this.long = this.$route.query.coords[1] || ''
        }
      }

      if (this.$route.query.radius) {
        if (typeof this.$route.query.radius === "string") {
          this.radiusMap = +this.$route.query.radius
        }
      }

      if (this.$route.query.searchTerm) {
        if (typeof this.$route.query.searchTerm === "string") {
          this.searchTerm = this.$route.query.searchTerm
        }
      }

    },
    loadCC() {
      this.state = LoadingState.loading
      //console.log('region,sortby-loadcc:',region,sortBy)

      let selectedRegion: any = undefined;

      // let radius = 0;
      //plz & kartensuche
      if (this.lat !== '' && this.long !== '') {
        // radius = 30
        // sort by entfernung
        this.sortCCby = 'distance:ASC'
        // console.log('sort by entfernung (plz-suche)')
      }

      //bundeslandsuche
      if ((this.lat === '' || this.long === '') && this.regions !== '') {
        // region = value[1]
        // sort by plz
        this.sortCCby = 'address.zipCode:ASC'
        // console.log('sort by plz (bundeslandsuche)')
        if (this.regions.toLowerCase() === "wien" || this.regions.toLowerCase() === "vienna") {
          selectedRegion = RegionType.Vienna
        } else if (this.regions.toLowerCase() === "niederösterreich" || this.regions.toLowerCase() === "lower_austria") {
          selectedRegion = RegionType.LowerAustria
        } else if (this.regions.toLowerCase() === "oberösterreich" || this.regions.toLowerCase() === "upper_austria") {
          selectedRegion = RegionType.UpperAustria
        } else if (this.regions.toLowerCase() === "salzburg" || this.regions.toLowerCase() === "salzburg") {
          selectedRegion = RegionType.Salzburg
        } else if (this.regions.toLowerCase() === "steiermark" || this.regions.toLowerCase() === "styria") {
          selectedRegion = RegionType.Styria
        } else if (this.regions.toLowerCase() === "burgenland" || this.regions.toLowerCase() === "burgenland") {
          selectedRegion = RegionType.Burgenland
        } else if (this.regions.toLowerCase() === "kärnten" || this.regions.toLowerCase() === "carinthia") {
          selectedRegion = RegionType.Carinthia
        } else if (this.regions.toLowerCase() === "tirol" || this.regions.toLowerCase() === "tyrol") {
          selectedRegion = RegionType.Tyrol
        } else if (this.regions.toLowerCase() === "vorarlberg" || this.regions.toLowerCase() === "vorarlberg") {
          selectedRegion = RegionType.Vorarlberg
        } else if (this.regions === this.$t('searchlist.allRegions')) {
          this.sortCCby = ''
        }

      }

      let lat1 = undefined
      let long1 = undefined

      if (this.lat === '' || this.long === '') {
        lat1 = undefined
        long1 = undefined
      } else {
        lat1 = +this.lat
        long1 = +this.long
      }

      //  console.log('long: '+long1+',lat '+lat1+',sortby '+this.sortCCby+',radius '+radius+',region:'+this.regions+', selectedregion:'+selectedRegion)

      let topicsList = Object.values(this.topics).join(",");

      let limit = 500
      //if seletedRegion === undefined/leer/alle bundesländer && long1 & lat1 === leer -> limit = 1000
      if ((this.regions === this.$t('searchlist.allRegions') || typeof selectedRegion === 'undefined' || this.regions === '') && (typeof lat1 === 'undefined' || typeof long1 === 'undefined')) {
        limit = 1000;
      }

      if (this.regions === '') { // Bitte nach PLZ aufsteigend sortieren, wenn kein Suchkriterium oder nur Beratungsthemen gesetzt sind.
        this.sortCCby = 'address.zipCode';
      }

      counselingCenterService.getCounselingCenters('', undefined, undefined, topicsList, undefined, ObjectStatus.Active, undefined, undefined, undefined, this.withOnlineCounseling, undefined, undefined, undefined, undefined, undefined, undefined, undefined, limit, undefined, this.sortCCby, undefined, long1, lat1, this.radiusMap, selectedRegion).then(result => {
        // console.log('centers von ViewErgebnisliste: ',result)
        this.cCenter = result
        this.filteredCenter = result.content as any
        this.countFilter(this.filteredCenter, '');
        this.filterCC('');
        if (this.showTargetGroup) {
          this.countAllTargetGroups(this.cCenter.content);
        }
        this.state = LoadingState.success
      }).catch(() => {
        this.state = LoadingState.success
      })
    },
    countAllTargetGroups(centers: any) {
      this.countTargetGroupAll = 0
      // console.log('count all tgs')

      if (centers) {

        let lang = Array.from(this.checkedLanguageType);
        let cType = Array.from(this.checkedCounselingType);

        let filtered = [] as any;

        for (let j = 0; j < centers.length; j++) {

          let lookupValueIds = centers[j].lookupValueIds || []
          if ((lang.length === 0 || lang.some((l: any) => lookupValueIds.includes(l)))
            && (cType.length === 0 || cType.some((c: any) => lookupValueIds.includes(c)))
          ) {
            filtered.push(centers[j])
          }
        }

        this.countTargetGroupAll = filtered.length || 0
      }
    },
    countFilter(centers: any, filterString: string) {

      let tempMap = new Map();
      let tempCMap = new Map();
      let tempTGMap = new Map();

      const tempCenter = centers;

      this.countChatSystems = 0;
      this.countVideoSystems = 0;
      this.countMailSystems = 0;
      this.countOnlineServicesAll = 0;

      if (tempCenter) {
        for (let j = 0; j < tempCenter.length; j++) {

          if (tempCenter[j].chatCounselingSystem && tempCenter[j].chatCounselingSystem !== CounselingSystemType.None) {
            this.countChatSystems++;
          }

          if (tempCenter[j].videoCounselingSystem && tempCenter[j].videoCounselingSystem !== CounselingSystemType.None) {
            this.countVideoSystems++;
          }

          if (tempCenter[j].mailCounselingSystem && tempCenter[j].mailCounselingSystem !== CounselingSystemType.None) {
            this.countMailSystems++;
          }

          if (tempCenter[j].chatCounselingSystem && tempCenter[j].chatCounselingSystem !== CounselingSystemType.None || tempCenter[j].videoCounselingSystem && tempCenter[j].videoCounselingSystem !== CounselingSystemType.None || tempCenter[j].mailCounselingSystem && tempCenter[j].mailCounselingSystem !== CounselingSystemType.None) {
            this.countOnlineServicesAll++;
          }

          let lookupValueIds = tempCenter[j].lookupValueIds || []

          if (filterString !== "lang") {
            this.getLanguageLookupValue.forEach((l: any, i: any) => {

              if (lookupValueIds.includes(l.id)) {

                if (tempMap.has(this.getLanguageLookupValue[i].id)) {
                  const add = tempMap.get(this.getLanguageLookupValue[i].id) + 1
                  tempMap.set(this.getLanguageLookupValue[i].id, add)
                } else {
                  tempMap.set(this.getLanguageLookupValue[i].id, 1)
                }
                return true
              } else {
                if (!tempMap.has(l.id)) {
                  tempMap.set(l.id, 0)
                }
                return true
              }
            })
          }

          if (filterString !== "ctype") {
            this.getCounselingTypeLookupValue.forEach((l: any, i: any) => {
              if (lookupValueIds.includes(l.id)) {
                if (tempCMap.has(this.getCounselingTypeLookupValue[i].id)) {
                  const add = tempCMap.get(this.getCounselingTypeLookupValue[i].id) + 1
                  tempCMap.set(this.getCounselingTypeLookupValue[i].id, add)
                } else {
                  tempCMap.set(this.getCounselingTypeLookupValue[i].id, 1)
                }
                return true
              } else {
                if (!tempCMap.has(l.id)) {
                  tempCMap.set(l.id, 0)
                }
                return true
              }
            })
          }

          if (this.showTargetGroup) {
            // if(filterString !== "tg"){
            this.getTargetGroupLookupValue.forEach((l: any, i: any) => {
              if (lookupValueIds.includes(l.id)) {

                if (tempTGMap.has(this.getTargetGroupLookupValue[i].id)) {
                  const add = tempTGMap.get(this.getTargetGroupLookupValue[i].id) + 1
                  tempTGMap.set(this.getTargetGroupLookupValue[i].id, add)
                } else {
                  tempTGMap.set(this.getTargetGroupLookupValue[i].id, 1)
                }

                return true
              } else {
                if (!tempTGMap.has(l.id)) {
                  tempTGMap.set(l.id, 0)
                }
                return true
              }
            })
            // }
          }

        }

      }

      //  console.log('countLang, countCouseling, countTargetG', tempMap, tempCMap, tempTGMap)
      if (filterString !== "lang") {
        this.countLang = tempMap
      }
      if (filterString !== "ctype") {
        this.countCounseling = tempCMap
      }
      if (this.showTargetGroup) {
        if (filterString !== "tg") {
          this.countTargetGroup = tempTGMap
        }
      }

    },
    countFilterOld(centers: any, filterString: string) {

      let tempMap = new Map();
      let tempCMap = new Map();
      let tempTGMap = new Map();

      const tempCenter = centers;

      if (tempCenter) {
        for (let j = 0; j < tempCenter.length; j++) {

          let lookupValueIds = tempCenter[j].lookupValueIds || []

          if (filterString === "lang") {
            this.getLanguageLookupValue.forEach((l: any, i: any) => {

              if (lookupValueIds.includes(l.id)) {

                if (tempMap.has(this.getLanguageLookupValue[i].id)) {
                  const add = tempMap.get(this.getLanguageLookupValue[i].id) + 1
                  tempMap.set(this.getLanguageLookupValue[i].id, add)
                } else {
                  tempMap.set(this.getLanguageLookupValue[i].id, 1)
                }
                return true
              } else {
                if (!tempMap.has(l.id)) {
                  tempMap.set(l.id, 0)
                }
                return true
              }
            })
          }

          if (filterString === "ctype") {
            this.getCounselingTypeLookupValue.forEach((l: any, i: any) => {
              if (lookupValueIds.includes(l.id)) {
                if (tempCMap.has(this.getCounselingTypeLookupValue[i].id)) {
                  const add = tempCMap.get(this.getCounselingTypeLookupValue[i].id) + 1
                  tempCMap.set(this.getCounselingTypeLookupValue[i].id, add)
                } else {
                  tempCMap.set(this.getCounselingTypeLookupValue[i].id, 1)
                }
                return true
              } else {
                if (!tempCMap.has(l.id)) {
                  tempCMap.set(l.id, 0)
                  // maybe bug with zero checkedtypes/lang/tg?
                  // console.log('alle:', this.checkedCounselingType)
                  // for (let m=0; m<this.checkedCounselingType.length; m++){
                  //   if(this.checkedCounselingType[m] === l.id){
                  //     console.log('found empty, now remove?m--?')
                  //   }
                  // }
                }
                return true
              }
            })
          }

          if (this.showTargetGroup) {
            if (filterString === "tg") {
              this.getTargetGroupLookupValue.forEach((l: any, i: any) => {
                if (lookupValueIds.includes(l.id)) {

                  if (tempTGMap.has(this.getTargetGroupLookupValue[i].id)) {
                    const add = tempTGMap.get(this.getTargetGroupLookupValue[i].id) + 1
                    tempTGMap.set(this.getTargetGroupLookupValue[i].id, add)
                  } else {
                    tempTGMap.set(this.getTargetGroupLookupValue[i].id, 1)
                  }

                  return true
                } else {
                  if (!tempTGMap.has(l.id)) {
                    tempTGMap.set(l.id, 0)
                  }
                  return true
                }
              })
            }
          }

        }

      }

      //  console.log('countLang, countCouseling, countTargetG', tempMap, tempCMap, tempTGMap)
      if (filterString === "lang") {
        // console.log('lang count old:', tempMap)
        this.countLang = tempMap
      }
      if (filterString === "ctype") {
        // console.log('ctype count old:', tempCMap)
        this.countCounseling = tempCMap
      }
      if (this.showTargetGroup) {
        if (filterString === "tg") {
          // console.log('tg count old:', tempTGMap)
          this.countTargetGroup = tempTGMap
        }
      }

    },
    filterCC(selectedType: string) {

      //filter bestehende cCenter
      let lang = Array.from(this.checkedLanguageType);
      let os = Array.from(this.checkedOnlineService);
      let cType = Array.from(this.checkedCounselingType);
      // let tg = Array.from(this.checkedTargetGroup);

      let tg = this.checkedTargetGroup;

      this.filteredCenter = this.cCenter.content as any

      let filtered = [] as any;
      if (this.filteredCenter) {

        for (let j = 0; j < this.filteredCenter.length; j++) {

          let legalName = _get(this.filteredCenter[j], 'legalEntities[0].name', '')
          let addressZip = _get(this.filteredCenter[j], 'address.zipCode')
          let addressCity = _get(this.filteredCenter[j], 'address.city')
          let addressStreetName = _get(this.filteredCenter[j], 'address.streetName')
          let addressHouseNumber = _get(this.filteredCenter[j], 'address.houseNumber')
          let addressSupplement = _get(this.filteredCenter[j], 'address.addressSupplement')

          let addressCombined = legalName + ' ' + addressZip + ' ' + addressCity + ' ' + addressStreetName + ' ' + addressHouseNumber + ' ' + addressSupplement;

          let lookupValueIds = this.filteredCenter[j].lookupValueIds || []

          let chatCheck = os.includes('Chat') && this.filteredCenter[j].chatCounselingSystem && this.filteredCenter[j].chatCounselingSystem !== CounselingSystemType.None;
          let videoCheck = os.includes('Video') && this.filteredCenter[j].videoCounselingSystem && this.filteredCenter[j].videoCounselingSystem !== CounselingSystemType.None;
          let mailCheck = os.includes('Mail') && this.filteredCenter[j].mailCounselingSystem && this.filteredCenter[j].mailCounselingSystem !== CounselingSystemType.None;

          if ((lang.length === 0 || lang.some((l: any) => lookupValueIds.includes(l)))
            && (cType.length === 0 || cType.some((c: any) => lookupValueIds.includes(c)))
            && (tg.length === 0 || lookupValueIds.includes(tg))
            && (os.length === 0 || (chatCheck || videoCheck || mailCheck))
            && (this.searchTerm.length === 0 || this.filteredCenter[j].name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              legalName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              addressCombined.toLowerCase().includes(this.searchTerm.toLowerCase())
            )) {
            filtered.push(this.filteredCenter[j])
          }
        }
      }
      if (filtered.length > 0) {
        this.filteredCenter = filtered
        this.countFilter(this.filteredCenter, selectedType)
        // this.countFilterOld(this.filteredCenterOld,selectedType)
      } else {
        this.filteredCenter = []
      }
    },

    searchArea(object: any) {
      // console.debug("object: ", object);
      // console.debug("center: ", object.lonLat);
      // console.debug("distance in meter: ", object.distance);
      // console.debug("distance in kilometer: ", object.distance / 1000);
      this.long = object.lonLat[0]
      this.lat = object.lonLat[1]
      this.radiusMap = object.distance / 1000
      this.regions = this.$t('searchlist.mapArea')
      this.pushUrl()
      this.loadCC()
      this.forceRerender()
    }

  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  }
});
</script>


<style scoped>
#mobileSwitch button {
  color: white;
  padding: 15px;
  text-transform: uppercase;
  text-decoration: none;
  box-shadow: none;
}

#mobileSwitch button:focus {
  /* outline: 1px solid gray; */
  outline: -webkit-focus-ring-color auto 1px;
}

@media screen and (max-width: 767px) {

  #ergebnis-filter,
  #karte-desktop {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-color: white;
    z-index: 999;
    padding-bottom: 80px;
  }

}

#search-menue {
  z-index: initial;
}

@media screen and (max-width: 767px) {

  #ergebnis-filter,
  #karte-desktop {
    height: auto;
  }
}

.overlayfixed {
  position: fixed !important;
  top: 0;
  left: 0;
  overflow: scroll;
  height: 100%;
  z-index: 200;
  padding-bottom: 140px;
  background-color: white;
}

.custom-search-button-delete {
  margin-right: 32px;
}

.frauen .btn-link-custom {
  color: #870038 !important
}

.familie .btn-link-custom {
  color: #217cab !important
}
</style>
